const { REACT_APP_API_PLACEHOLDER } = process.env
export const ORDERS             = REACT_APP_API_PLACEHOLDER + '/orders'



// WEBPACK FOOTER //
// ./src/features/OrderDetails/apiConst.js